"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./index.scss");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Error = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Error, _React$Component);
  var _super = _createSuper(Error);
  function Error() {
    (0, _classCallCheck2.default)(this, Error);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(Error, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "root"
      }, this.props.applicantInfo ? /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "additional-transaction"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-12"
      }, "Additional transaction for ", /*#__PURE__*/_react.default.createElement("strong", null, " ", this.props.applicantInfo.firstName, " ", this.props.applicantInfo.lastName, " ")), /*#__PURE__*/_react.default.createElement("div", {
        className: "close-modal"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "pull-right",
        "data-dismiss": "modal"
      }, "X")))) : null, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "error-container"
      }, "Sorry, the transaction failed with status ", this.props.isError)));
    }
  }]);
  return Error;
}(_react.default.Component);
Error.propTypes = {
  applicantInfo: _propTypes.default.arrayOf({
    firstName: _propTypes.default.string,
    lastName: _propTypes.default.string
  }),
  isError: _propTypes.default.string
};
var _default = Error;
exports.default = _default;
